import { select, on, getAttribute, getData } from 'modules/dom'
import { getProp, setProp } from 'modules/utils'

export default function (el) {
  const versionSelect = select('.js-select', el)
  const currentEl = select('.js-current', el)
  const versionOptions = getProp('options', versionSelect)
  const getSelectedOption = function() {
    let selectedIndex = getProp('selectedIndex', versionSelect)
    return versionOptions[selectedIndex]
  }
  const setCurrentText = function() {
    let selectedOption = getSelectedOption()
    setProp('innerHTML', getData('label', selectedOption), currentEl)
  }
  const handleSelect = function(e) {
    let selectedVersion = getProp('value', versionSelect) || 'direct_instruction'
    let linkEl = select(`[data-resource-version="${selectedVersion}"]`)
    let url = getAttribute('href', linkEl)
    window.location = url
    setCurrentText()
  }
  setCurrentText()
  on('change', handleSelect, versionSelect)
}
